import React from "react";
import { ASSETS, CONTACT_INFO, NAV_LINKS } from "../data/entrepminds";

const goTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[#e8e2cf] pt-16 pb-10 bg-[#faf7ee]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <img
              src={ASSETS.logo}
              alt="Entrepminds"
              className="h-14 w-auto mb-5 object-contain"
            />
            <p className="text-[#6b6356] text-sm leading-relaxed max-w-sm">
              AI-powered business transformation systems — built, integrated and
              operated by Entrepminds Management Consultancy.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-em text-[10px] tracking-[0.25em] uppercase text-[#8a6a10] mb-4">
              Navigate
            </div>
            <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-sm">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => goTo(l.id)}
                  data-testid={`footer-link-${l.id}`}
                  className="text-left text-[#3f3a30] hover:text-[#8a6a10] transition-colors w-fit"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-em text-[10px] tracking-[0.25em] uppercase text-[#8a6a10] mb-4">
              Reach us
            </div>
            <div className="text-sm space-y-2">
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="block text-[#3f3a30] hover:text-[#8a6a10] transition-colors break-all"
              >
                {CONTACT_INFO.email}
              </a>
              <div className="text-[#6b6356]">{CONTACT_INFO.address}</div>
            </div>
          </div>
        </div>

        <div className="gold-divider" />

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#6b6356]">
          <div>
            © {new Date().getFullYear()} Entrepminds Management Consultancy. All
            rights reserved.
          </div>
          <div className="font-mono-em tracking-[0.25em] uppercase">
            Diagnose · Optimize · Automate · Scale
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
